import { useStyles, Dialog, pxToRem } from '@archipro-design/aria';

import React, { useRef } from 'react';

import { ProfileModal } from './ProfileModal';
import { useClickAway } from 'ahooks';
import * as S from './TeamMemberDetailsModal.style';
import type { TeamMemberView } from '@modules/professional/type/team-member';

export const TeamMemberDetailsModal: React.FC<{
    member: TeamMemberView;
    website: string | null;
    toggleModal: () => void;
    isOpen: boolean;
}> = ({ member, website, toggleModal, isOpen }) => {
    const { css } = useStyles();
    const modalRef = useRef(null);

    useClickAway(() => {
        toggleModal();
    }, [modalRef]);

    if (member === null) return null;

    return (
        <Dialog
            className={css(S.TeamMemberDialofStyle)}
            ref={modalRef}
            open={isOpen}
            trapFocus={false}
            header={{
                content: (
                    <>
                        <div
                            className={css(S.CloseButton)}
                            onClick={() => {
                                toggleModal();
                            }}
                        >
                            Close
                        </div>
                        <div className={css(S.TeamMemberTop)}>Team member</div>
                    </>
                ),
                style: S.TeamMemberHeaderStyle,
            }}
            content={{
                content: (
                    <ProfileModal website={website} memberDetails={member} />
                ),
                className: css(S.TeamMemberWrapper),
            }}
            footer={{
                style: { padding: '0' },
            }}
            variables={{
                border: 0,
                rootBorderRadius: 0,
                rootWidth: pxToRem(620),
            }}
        />
    );
};
